import React from 'react';
import { Layout } from 'antd';
import "./styles.scss";

export const LayoutTopSide = ({ children, ...props }) => (
  <Layout className="layout-top-side" {...props}>{children}</Layout>
);
